export function loadingInstance (Loading) {
  let loadingInstance = Loading.service({
    background: 'rgba(255,255,255, 0)'
  })
  return loadingInstance
}

export function formatDate (now) {
  let year = now.getFullYear()
  let month = now.getMonth() + 1 >= 10 ? now.getMonth() + 1 : '0' + (now.getMonth() + 1)
  let date = now.getDate() >= 10 ? now.getDate() : '0' + now.getDate()
  return year + '-' + month + '-' + date
}

export function Success (ele, res) {
  return ele.$message({
    message: res.message,
    type: 'success'
  })
}

export function Error (ele, res) {
  return ele.$message({
    message: res.message,
    type: 'error'
  })
}

export function ErrorInfo (ele, res) {
  return ele.$alert(res.message, '提交错误', {
    confirmButtonText: '关闭',
    customClass: 'ErrorInfoClass'
  })
}


function formatDate1(date,fmt) {
    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "H+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

//大订单状态
export const orderStatus={
  0:'待支付',
  1:'已支付',
  '-1':'取消支付',
  '-2':'订单超时未支付',
}

//子订单状态
export const zOrderStatus={
  101:'待支付',
  102:'取消支付',
  103:'超时订单未支付',
  201:'待自提',
  202:'已自提（完成）',
  203:'已评价',
  301:'待发货',
  302:'已发货',
  303:'已收货（完成）',
  304:'已评价',
  401:'申请退货',
  402:'退款成功',
  403:'退款失败',
  501:'申请退换',
  502:'退换中',
  503:'退换完成'
}



// WEBPACK FOOTER //
// ./src/common/js/util.js